import { ChatSocket } from '../../hooks/use-socket';
import { getQuery } from '../../lib/query';
import { current } from '../../stores/backend';
import { openModal } from '../../stores/backend/meta';
import {
    ChatEvent,
    FreeplayEvent,
    FreeplayRestriction,
} from '../../types/bingo-events/in/chat/event';

const isFreeplayEvent = (response: ChatEvent): response is FreeplayEvent =>
    response.type === 'FREEPLAY' &&
    typeof response.body === 'object' &&
    response.body !== null;

const matchesRestriction = (
    restriction: FreeplayRestriction | null | undefined
) => {
    if (!restriction) return true;

    const { ROOMID } = getQuery();
    const currentRoomId = Number(ROOMID);
    const currentCurrency = current.game_currency.value.toUpperCase();

    const roomMatches =
        restriction.roomId === undefined ||
        restriction.roomId.includes(currentRoomId);
    const currencyMatches =
        restriction.currency === undefined ||
        restriction.currency.some(
            (currency) => currency.toUpperCase() === currentCurrency
        );

    return roomMatches && currencyMatches;
};

export const onEvent = (socket: ChatSocket, refreshAccount?: () => void) => {
    const callback = (response: ChatEvent) => {
        if (!isFreeplayEvent(response)) return;
        if (!matchesRestriction(response.body.restriction)) return;

        refreshAccount?.();
        openModal({ key: 'fpeToken' });
    };

    socket.on('event:parlay', callback);

    return () => {
        socket.off('event:parlay', callback);
    };
};
